<template>
    <div id="color-page">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                icon="arrow-left"
                :action="() => $router.push('/coloroverview')"
                :label="trans('pages.color_page.to_overview')"
            />
            <actions-menu-item
                :v4="true"
                icon="pencil"
                :action="() => $router.push('/editcolorpage/' + idParam)"
                :label="trans('pages.color_page.edit')"
            />
            <actions-menu-item
                :v4="true"
                :action="removeColor"
                class="alert"
                icon="trash-o"
                :label="trans('pages.color_page.delete')"
            />
        </actions-menu>

        <spinner-text v-if="loading">
            {{ trans('pages.color_page.loading') }}
        </spinner-text>
        <template v-else>
            <div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.ral_nr') }}
                    </div>
                    <div class="profilepagevalue">{{ color.ralnr }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.ral_type') }}
                    </div>
                    <div class="profilepagevalue">{{ color.raltype }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.powder_nr') }}
                    </div>
                    <div class="profilepagevalue">{{ color.poedernr }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.powder_nr2') }}
                    </div>
                    <div class="profilepagevalue">{{ color.poedernr2 }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.powder_nr3') }}
                    </div>
                    <div class="profilepagevalue">{{ color.poedernr3 }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.description') }}
                    </div>
                    <div class="profilepagevalue">{{ color.description }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.producer') }}
                    </div>
                    <div class="profilepagevalue">{{ color.producent }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.tendon') }}
                    </div>
                    <div class="profilepagevalue">{{ color.tendon }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.default_color') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ boolToYesNo(color.defaultColor == 1) }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.order') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ color.order ? color.order : '' }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.color_page.powder') }}
                    </div>
                    <div class="profilepagevalue">
                        {{
                            color.powderCode
                                ? color.powderCode +
                                  ' ' +
                                  color.powderDescription
                                : ''
                        }}
                    </div>
                </div>
            </div>
            <div>
                <h2>{{ trans('pages.color_page.suppliers') }}</h2>
                <table class="striped-table">
                    <thead>
                        <tr>
                            <th rowspan="2">
                                {{ trans('pages.color_page.supplier') }}
                            </th>
                            <th rowspan="2">
                                {{ trans('pages.color_page.show') }}
                            </th>
                            <th colspan="2">
                                {{ priceFieldLabel(1) }}
                            </th>
                            <th colspan="2">
                                {{ priceFieldLabel(2) }}
                            </th>
                            <th colspan="2">
                                {{ priceFieldLabel(3) }}
                            </th>
                        </tr>
                        <tr>
                            <template v-for="n in priceFields">
                                <th :key="'h-default-' + n">{{ trans('pages.color_page.default_color_question') }}</th>
                                <th :key="'h-price-' + n">{{ trans('pages.color_page.price_category') }}</th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="supplier in attachedSuppliers"
                            :key="'attached-supplier-' + supplier.id"
                        >
                            <td>
                                <div>
                                    <b>{{ supplier.name }}</b>
                                </div>
                                <br />
                                <div>
                                    {{ trans('pages.color_page.supplier_of') }}
                                </div>
                                <ul>
                                    <li
                                        v-for="productType in supplier.productTypes"
                                    >
                                        {{ productType.externalName }}
                                    </li>
                                </ul>
                            </td>
                            <td>{{ supplier.isActive != null ? boolToYesNo(supplier.isActive) : '-' }}</td>
                            <template v-for="n in priceFields">
                                <td :key="'standard-' + n">{{ supplier['isStandardPricefield' + n] != null ? boolToYesNo(supplier['isStandardPricefield' + n]) : '-' }}</td>
                                <td :key="'price-' + n">{{ supplier['priceCategoryIdPricefield' + n] || '-' }}</td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import colorApi from '../api/color';
import priceListLabelsApi from '../api/priceListLabels';
import SpinnerText from '../components/loader/SpinnerText';
import IdParamMixin from '../mixins/id-param';
import OutputHelper from '../helpers/OutputHelper';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), localization],
    components: { SpinnerText, ActionsMenu, ActionsMenuItem },
    computed: {
        noCaps() {
            return OutputHelper.capitalization.noCaps;
        },
    },
    data() {
        return {
            priceFields: [1, 2, 3],
            loading: false,
            color: null,
            attachedSuppliers: [],
            priceListLabels: [],
        };
    },
    methods: {
        boolToYesNo: OutputHelper.boolToYesNo,
        priceFieldLabel(n) {
            const entry = this.priceListLabels.find(
                (label) => label.priceListIndex === n - 1
            );

            return (entry && entry.label) || this.trans('pages.color_page.price_field_label', { n });
        },
        removeColor() {
            showConfirmDialog({
                title: this.trans('pages.color_page.delete_color_title'),
                content: this.trans(
                    'pages.color_page.delete_color_confirmation'
                ),
                confirm: () => {
                    colorApi
                        .remove(this.idParam)
                        .then(() => {
                            showInfoMessage(
                                this.trans('pages.color_page.color_deleted')
                            );
                            this.$router.push('/coloroverview');
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans(
                                    'pages.color_page.color_delete_error'
                                )
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.color_page.yes'),
                cancelButton: this.trans('pages.color_page.no'),
            });
        },
        load() {
            const colorId = this.idParam;
            this.loading = true;
            Promise.all([
                colorApi.fetch(colorId).then((response) => {
                    const data = response.data;
                    const color = data.data;
                    this.$store.commit(
                        'general/setPageTitle',
                        color.ralnr + color.raltype + ' ' + color.poedernr
                    );
                    this.color = color;
                }),
                colorApi.fetchAttachedSuppliers(colorId).then((response) => {
                    this.attachedSuppliers = response.data.data;
                }),
                priceListLabelsApi.fetch()
                    .then((response) => {
                        this.priceListLabels = response.data.data;
                    })
                    .catch(() => {
                        this.priceListLabels = [];
                    }),
            ]).then(() => {
                this.loading = false;
            });
        },
    },
};
</script>
